<template>
  <div class="ui-container" :style="containerStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Максимальная ширина контента (px). По умолчанию 1200. */
    maxWidth?: number
  }>(),
  { maxWidth: 1200 },
)

const containerStyle = computed(() =>
  props.maxWidth ? { maxWidth: `${props.maxWidth}px` } : undefined,
)
</script>

<style scoped>
.ui-container {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
}

@media (max-width: 960px) {
  .ui-container {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
